<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ویرایش لینک</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.url_link.val" :description="form.url_link.inv" dir="ltr" label="لینک" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ویرایش</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                url_link: {val: '', inv: '', v: { req: true, max: 512, spec: 'url' }},
                is_active: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            users: [],
        }
    },
    mounted() {
        this.get_users();
        this.get_links();
	},
    methods: {
        get_links(){
            this.axios.get('/user_urls/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    for(const key in res.data[0]){
                        for(const k in this.form){
                            if(key == k){
                                if(key == 'is_active'){
                                    this.form[k].val = `${res.data[0][key]}`;
                                } else {
                                    this.form[k].val = res.data[0][key];
                                } 
                            }
                        }
                    }
                })
        },
        get_users(){
            this.axios.get('users/?type=update_user_links')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                });
            })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                data.set('ids', JSON.stringify([parseInt(this.$route.params.id)]));
                this.axios.put('user_urls/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ویرایش با موفقیت انجام شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_update_link_for_all_users == false
            && this.$store.state.perms.can_update_link_for_same_group_user == false
            && this.$store.state.perms.can_update_link == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
